import React from "react";
import "./Version.scss";

interface VersionProps {
  version: string;
  hide?: boolean;
}

export const Version: React.FC<VersionProps> = ({version, hide}) => {
  if (!version || hide) {
    return null;
  }

  return (
    <div className="version-container">
      <div className="version-item">Version: {version}</div>
    </div>
  );
};
